<template>
  <div class="text-gray-300 text-9xl text-center mt-64 select-none">
    4 0 4
  </div>
</template>
